module.exports = __webpack_public_path__ + "static/media/leafly-white.1bf542c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/leafly-white.svg
// module id = 2436
// module chunks = 0